module.exports = __webpack_public_path__ + "static/media/eblan.05b31592.png";